import Loadable from "@loadable/component";

const ProtectedCaptchaPage = Loadable(
  () => import(/* webpackChunkName: "captcha_loader_page" */ "./captchaLoader")
);

export default ProtectedCaptchaPage;
